import dao from './dao';

export default dao.reducer;
